'use strict';

import React, { Component } from 'react'

import { MdLockOutline } from 'react-icons/md'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import HolidaysIcon  from '@/Icons/Holidays'
import TicketIcon    from '@/Icons/Ticket'
import ArtistIcon    from '@/Icons/Artist'

import GetActivePrivateSales from '@fetcher/GetActivePrivateSales'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

const { app, qwest } = window;

export default class AllCatalogPage extends Component
{
	state =
	{
		searched:
		{
			value: ''
		}
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	handlePrivateSales = (private_sales) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ private_sales: private_sales });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const holidays_block =
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img c-color-block--sejours">

					<HolidaysIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Séjours &amp; vacances
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/sejours-vacances"
					/>

				</div>

			</div>
		);

		const products_block =
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img
					c-color-block--places">

					<TicketIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Billetteries
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/accueil/catalogue"
					/>

				</div>

			</div>
		);

		const artists_block =
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block c-color-block--img
					c-color-block--artists">

					<ArtistIcon className="o-inline-icon c-color-block__icon" />

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Les artistes &amp; festivals
						</div>
					</div>

					<Link className="c-color-block__link" href="/accueil/artistes" />
				</div>

			</div>
		);

		const private_sales = (state.private_sales || []).map(function (private_sale)
		{
			return (
				<div className="o-grid__item u-flex" key={ private_sale.id }>

					<div className="c-color-block c-color-block--img
						c-color-block--private-sale">

						<MdLockOutline className="o-inline-icon c-color-block__icon" />

						<div className="c-color-block__content">
							<div className="c-color-block__title">
								Vente privée { private_sale.title }
							</div>
						</div>

						<Link className="c-color-block__link"
							href={ '/VP-' + private_sale.slug }
						/>
					</div>

				</div>
			);
		});

		const output =
		(
			<Layout history={ props.history }>

				<div className="page-content u-padding-top-15">

					<HolidaysMessage />

					<div className="u-full-width u-margin-bottom-15">

						<div className="front-dashboard-search">
							<SearchBar className="c-searchbar c-searchbar--front
								u-margin-top-0 u-margin-bottom-0"
								hide_btn={ true } placeholder="Rechercher dans le catalogue"
								data={ [] }
								handleChange={ component.handleSearch }
								value={ state.searched.value }
								onFocus={ e => app.emit('open__GlobalSearchResults') }
								autoFocus={ false }
							/>
						</div>

					</div>

					<div className={ 'o-grid-' +
						(state.private_sales?.length === 1 ? '4' : '3') +
						' u-flex home-grids' }>
						{ holidays_block }
						{ products_block }
						{ artists_block }
						{ private_sales }
					</div>

				</div> { /* /page-content */ }

				<GetActivePrivateSales onSuccess={ component.handlePrivateSales } />

			</Layout>
		);

		return output;
	}
}